import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-04/lesson-29/task-02";

const task: Slide = {
  titleHtml: "The pressure matching algorithm with the cost function used in this lesson:",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
